import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_FiltersCheckgroups = _resolveComponent("FiltersCheckgroups")
  const _component_Filters = _resolveComponent("Filters")
  const _component_FiltersDropdown = _resolveComponent("FiltersDropdown")

  return (_openBlock(), _createBlock(_component_FiltersDropdown, {
    title: $props.title,
    width: $props.width,
    "got-filter": !!_ctx.value.length
  }, {
    default: _withCtx(({close}) => [
      _createVNode(_component_Filters, {
        modelValue: _ctx.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.value) = $event)),
        title: $props.title,
        onOnApply: $event => (close())
      }, {
        default: _withCtx(() => [
          _createVNode(_component_FiltersCheckgroups, { items: $props.items }, null, 8 /* PROPS */, ["items"])
        ]),
        _: 2 /* DYNAMIC */
      }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["modelValue", "title", "onOnApply"])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["title", "width", "got-filter"]))
}